import './modules/toggler';
import './modules/scroll-link';
import homeSatiation from './modules/home-satiation';
import './modules/connector';
import initFlickity from './modules/run-flickity';
import './modules/image-gallery';
import './helpers/url-params';
import './modules/google-map'

'use strict';
/* global initFlickity:false */
/* global homeSatiation:false */
/* global LazyLoad */

/**
 * Global Variables
 *
 */
window.global = {
    body: $(document.body),
    bpLarge: 128,
    bpIPadMax: 1024,
    bpMedium: 960,
    bpIPadMin: 768,
    bpSmall: 640,
    bsLGB: 992
};

/**
 * Use it if you want to render some function or plugin or variable in certain page.
 * If you want to use on more than one use the page and logical OR (||) in JavaScript eg. 'page.simple || page.room'
 *
 * If page object is inside document.ready it is not visible outside of it.
 *
 * */
window.page = {
    all          : true, // Pass on every page
    home         : window.global.body.hasClass('home'),
    simpleList   : window.global.body.hasClass('page-template-simple-list'),
    simple       : window.global.body.hasClass('page-template-simple'),
    roomList     : window.global.body.hasClass('page-template-rooms'),
    room         : window.global.body.hasClass('single-room'),
    photoGallery : window.global.body.hasClass('page-template-gallery'),
    loyalty      : window.global.body.hasClass('page-template-loyalty'),
    location     : window.global.body.hasClass('page-template-location'),
    contact      : window.global.body.hasClass('page-template-contact'),
};

/**
 * breakpoints
 */
window.width = $(window).width();
window.windowInnerWidth = window.innerWidth || $(window).width();
window.windowInnerHeight = window.innerHeight || $(window).height();

if (window.width !== window.windowInnerWidth) {
    window.scrollBar = true;
}

var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazyload",
});

$(document).ready( () => {

    window.global.body.detectScroll({
        enterLength: 101,
        comingClass: '',
        visibleClass: 'scrolling',
        leaveClass: ''
    });

    $('#menu-toggle').toggler({
        bodyClass: 'menu-is-open',
        targetClass: false,
        triggerClass: false
    });

    if ( window.page.home ) {

        // $('#hero-home').anchorScroll({
        //     triggerElement: '.scroll-down',
        //     headerId: '',
        //     speed: 500,
        //     breakpoint: true,
        //     page: true,
        // });

        $('.scroll-down').scrollLink({
			header: '#navbar .navbar-items'
		});

        $('#home-intro').detectScroll({
            comingClass: '',
            visibleClass: 'is-visible',
            leaveClass: '',
            invisibleClass: 'is-invisible',
            enterLength: 30,
            leaveLength: 30
        });

        homeSatiation();

    }

    if ( $('#fixed-message').length > 0 ) {
        var messageHeight = $('#fixed-message').outerHeight();
        $('.navbar-wrapper').css('margin-top',messageHeight);
        $('.menu__header').css('margin-top',messageHeight);
        if ($(window).width() <= 960) {
            $('#page-wrapper').css('margin-top',messageHeight);
        }
    }

	$(document).ready(function(){
		var video1 = document.getElementById("ban_video");
		if (video1)
			video1.currentTime = 0;
		$(".mute-bt").click(function(){
			if($(this).hasClass("stop"))
			{
				var ban_video = document.getElementById("ban_video");
				$("#ban_video").prop('muted', true);
				$(this).removeClass("stop");
			}
			else{
				var ban_video = document.getElementById("ban_video");
				$("#ban_video").prop('muted', false);
				$(this).addClass("stop");
			}
		});

		$(".play-bt").click(function(){
			$(".play-bt").hide();
			$(".pause-bt").show();
			var ban_video = document.getElementById("ban_video");
			if($(".stop-bt").hasClass("active")){
				ban_video.currentTime = 0;
			}
			if (typeof ban_video !== "undefined")
				ban_video.play();
		});
		$(".pause-bt").click(function(){
			$(".play-bt").show();
			$(".pause-bt").hide();
			$(".pause-bt").addClass("active");
			$(".stop-bt").removeClass("active");
			var ban_video = document.getElementById("ban_video");
			if (typeof ban_video !== "undefined")
				ban_video.pause();
		});
		$(".stop-bt").click(function(){
			$(".play-bt").show();
			$(".pause-bt").hide();
			$(".pause-bt").removeClass("active");
			$(".stop-bt").addClass("active");
			var ban_video = document.getElementById("ban_video");
			if (typeof ban_video !== "undefined")
				ban_video.pause();
		});
		if ($(window).width() < 961) {
			$(".play-bt").show();
			$(".pause-bt").show();
			$(".pause-bt").removeClass("active");
			$(".stop-bt").addClass("active");
		} else {
			$(".play-bt").hide();
			$(".pause-bt").show();
			var ban_video = document.getElementById("ban_video");
			if (typeof ban_video !== 'undefined' && ban_video !== null) {
				if($(".stop-bt").hasClass("active")){
					ban_video.currentTime = 0;
				}
				ban_video.play();
			}
		}
	});

});


$(window).on('load', () => {

	if (window.page.home || window.page.room || window.page.simple ) {
		initFlickity($('#slider-gallery'));
	}

	if ( window.page.photoGallery ) {
		$('#masonry-gallery').isotopeGallery({
			galleryFilters: '#masonry-gallery-filters a',
			useUrlParams: true
		}).photoSwipeGallery({
			galleryFilters: '#masonry-gallery-filters a',
			useUrlParams: true
		});
	}
});
